export const EvaluationForm = {

  init: function () {
    this.initialized = false;
    this.isEditable = false;
    this.application = {};
    this.totalScore = 0;
  }

}
export default EvaluationForm